import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import { SelectOption } from '../../shared/models/dropdowm.model';
import { ProductStatus } from '../models/product.model';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(
    pageNumber: number,
    pageSize: number,
    name?: string,
    sku?: string,
    status?: ProductStatus
  ) {
    let params = '';

    if (name) params += `&name=${name}`;
    if (sku) params += `&sku=${sku}`;
    if (status) params += `&status=${status}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/products?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(this.apiBaseUrl + '/api/v1/products/' + id);
  }

  getAllDropdown() {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + `/api/v1/products/dropdown`
    );
  }

  create(data: FormData) {
    return this.http.post<ApiResult>(
      this.apiBaseUrl + '/api/v1/products',
      data
    );
  }

  update(id: string, data: FormData) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/products/' + id,
      data
    );
  }

  getProductStatusOptions(): SelectOption[] {
    return [
      { label: 'Rascunho', value: ProductStatus.Draft },
      { label: 'Ativo', value: ProductStatus.Active },
      { label: 'Inativo', value: ProductStatus.Inactive },
    ];
  }
}
